import React, { ReactNode } from 'react';
import { InfoButton } from '@insurancemenu/imenu-components-lib/dist/icons';
import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { ICustomizableElement, ITestingElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { CONFIRMATION_BUTTON_TEST_ID, DISABLED_MESSAGE_TEST_ID } from '../constants';
import { WrapperStyled, TitleStyled, MessageStyled, ActionsWrapperStyled, DisabledMessageStyled } from './styles';

interface Props extends ICustomizableElement, ITestingElement {
  title: string;
  message: ReactNode;
  btnText: string;
  onConfirm(): void | Promise<void>;
  disabled?: boolean;
  disabledMessage?: ReactNode;
}

const ConfirmationBlob: React.FC<Props> = (props) => {
  const { title, message, btnText, onConfirm, className, disabled = false, disabledMessage } = props;

  return (
    <WrapperStyled data-test-id={props['data-test-id']} className={className}>
      <InfoButton width="4rem" color={colors.blue[600]} />
      <TitleStyled>{title}</TitleStyled>
      <MessageStyled>{message}</MessageStyled>

      <ActionsWrapperStyled>
        <Button
          onClick={onConfirm}
          size="large"
          color="primary"
          width="25rem"
          disabled={disabled}
          data-test-id={CONFIRMATION_BUTTON_TEST_ID}
        >
          {btnText}
        </Button>
        {disabled && disabledMessage ? (
          <DisabledMessageStyled data-test-id={DISABLED_MESSAGE_TEST_ID}>{disabledMessage}</DisabledMessageStyled>
        ) : null}
      </ActionsWrapperStyled>
    </WrapperStyled>
  );
};

export default ConfirmationBlob;
